import { makeAuthTypeFromSPIAuthType, makeScopeKey, makeTwoLeggedAuthType, makeUserFromSPIUser } from '@atlassian/mpac-types';
import { CapabilitySet, MarketplaceStoreEditionType } from '@atlassian/mpac-types/client-graphql-schema-types';
import { Either } from 'funfix-core';
import { List, Record } from 'immutable';
import { makeAppDisplayDetails, makeSPIAppDisplayDetails, makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails } from './AppDisplayDetails';
import { makeFreePaymentModel, makePaymentModelFromSPIPaymentModel } from './PaymentModel';
export const makeInstallationId = installationId => installationId;
// Private so that consumers use makeInstalledApp which more strongly enforces providing of the original InstalledAddon
export const _makeInstalledApp = Record({
  // Casting to any here since it's a bit too much overhead to define a massive default for something we never interact with
  _original: {},
  authType: makeTwoLeggedAuthType(),
  configureUrl: undefined,
  details: makeSPIAppDisplayDetails(makeAppDisplayDetails()),
  getStartedUrl: undefined,
  installationId: '',
  installTime: new Date(),
  installUser: undefined,
  manageAppUrl: undefined,
  marketplaceAppDetails: undefined,
  scopes: List(),
  uninstallInProgress: false,
  upgradeAvailable: false,
  paymentModel: Either.left(makeFreePaymentModel()),
  edition: undefined
});
export const makeInstalledApp = _makeInstalledApp;
export const makeCapabilitySetToEdition = capabilitySet => {
  if (capabilitySet === CapabilitySet.CapabilityStandard) return MarketplaceStoreEditionType.Standard;
  if (capabilitySet === CapabilitySet.CapabilityAdvanced) return MarketplaceStoreEditionType.Advanced;
  return undefined;
};
export const makeInstalledAppFromSPIInstalledApp = installedAddon => makeInstalledApp({
  _original: installedAddon,
  authType: makeAuthTypeFromSPIAuthType(installedAddon.authType),
  configureUrl: installedAddon.configureUrl,
  details: makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails(installedAddon.details),
  getStartedUrl: installedAddon.getStartedUrl,
  installationId: installedAddon.installationId,
  installTime: installedAddon.installTime,
  installUser: installedAddon.installUser ? makeUserFromSPIUser(installedAddon.installUser) : undefined,
  manageAppUrl: installedAddon.manageAppUrl,
  scopes: List(installedAddon.scopes).map(makeScopeKey),
  uninstallInProgress: false,
  upgradeAvailable: !installedAddon.latestVersion,
  paymentModel: makePaymentModelFromSPIPaymentModel(installedAddon.paymentModel),
  edition: makeCapabilitySetToEdition(installedAddon.capabilitySet)
});